import React from 'react'
import { Box, Button, Paper, Typography } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { HOME } from '../_constants/routes'
import ImageLost from '../images/lost.jpg'
import { useNavigate } from 'react-router-dom'


const NotFoundPage = () => {
  
  const navigate = useNavigate()
  
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      position: 'relative',
      background: `url(${ImageLost}) no-repeat center center fixed`,
      backgroundSize: 'cover',
    }}>
      <Paper sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '75%',
        maxWidth: 364,
        position: 'relative',
        p: 4,
        background: 'background.default',
        color: 'rgb(14, 30, 37)',
        borderRadius: 1,
      }}>
        <Typography variant='h5' gutterBottom align='center'>
          Erreur 404: Not found
        </Typography>
        <Typography variant='body1' gutterBottom align='center'>
          Are you lost ?
        </Typography>
        <Button variant='contained' color='primary' fullWidth onClick={() => navigate(HOME)} sx={{ mt: 1 }}>
          <ArrowBackIosIcon/>
          Back to app
        </Button>
      </Paper>
    </Box>
  )
}

export default NotFoundPage
